export enum WorkflowStatus {
  COMPLETED = 'COMPLETED',
}

export enum WorkflowItemCode {
  GENCONTENT = 'GENCONTENT',
  TASKLIST = 'TASKLIST',
  MFSTASKLIST = 'MFSTASKLIST',
  EXPASSES = 'EXPASSES',
  EXPQUIZ = 'EXPQUIZ',
  QU = 'QU',
  RN = 'RN',
  RPT = 'RPT',
  BIODATA = 'BIODATA',
  EXPVIDEOTASK = 'EXPVIDEOTASK',
  FORMS = 'FORMS',
  BASICTASKLIST = 'BASICTASKLIST',
  LANDING_PAGE = 'LANDING_PAGE',
}

export const WorkflowItemAssessmentCodes = [WorkflowItemCode.EXPASSES, WorkflowItemCode.EXPQUIZ];

export const workflowEndDefaultConfig = {
  assessmentCompletionURL: null,
  assessmentNonCompletionURL: null,
  integrated: false,
};
